import React from "react";

const BusinessModel = () => {
  return (
    <React.Fragment>
      <h1>Business Model</h1>

      <p>
        The business model of Cureus Journals is unique among academic journals. As an open access
        publisher, CJCS makes all content freely available to all readers worldwide immediately upon
        publication, ensuring maximum dissemination of articles, posters, and abstracts. Readers can
        read and download content without registering for an account.
      </p>

      <h3>Author Fees</h3>
      <p>
        Journals cover publishing costs by accepting article processing charges (APCs). However,
        CJCS does not stipulate any APCs. However, we do charge an editing fee if the submitted
        version has excessive errors that require the attention of a dedicated scientific editor. On
        the other hand, if manuscripts are significantly error-free and drafted in compliance with
        our rigorous formatting and language requirements, they qualify for zero editing fees.
      </p>
      <p>
        Articles that exceed our author or reference limits or contain too many formatting and
        language errors are required to purchase CJCS’s{" "}
        <a href="/cureus_editing_services" target="_blank" rel="noopener">
          Preferred Editing Service
        </a>{" "}
        before entering peer review. All non-channel review articles require the purchase of our{" "}
        <a href="/cureus_editing_services" target="_blank" rel="noopener">
          Preferred Editing Service
        </a>
        . Pricing is based on the following criteria:
      </p>
      <ul className="indented-for-medium-up">
        <li className="check">Formatting and language errors</li>
        <li className="check">Article length</li>
        <li className="check">Author count</li>
        <li className="check">Reference count</li>
      </ul>

      <p>
        The greater the amount of editing work required, the higher the price of Preferred Editing.
        Author fees do not influence editorial decision-making. For more information on our
        Preferred Editing Service, including a price estimation calculator, please refer to our{" "}
        <a href="/cureus_editing_services" target="_blank" rel="noopener">
          Preferred Editing
        </a>{" "}
        page.
      </p>

      <h3>Academic Channel Subscriptions</h3>
      <p>
        CJCS offers an annual subscription-based publishing service to universities, institutes, and
        professional societies/groups. Bypassing the need for our Preferred Editing service, CJCS
        academic channels serve as a branded showcase for organizations, their members, and their
        peer-reviewed articles.{" "}
        <a href="/channels" target="_blank" rel="noopener">
          {" "}
          Click here to learn more about our academic partnership program
        </a>
        . Note:{" "}
        <u>
          All manuscripts, whether submitted through our partnership program or as regular
          submissions, undergo a rigorous single-blind peer review.
        </u>{" "}
        We state this explicitly in our partnership contract, thus ensuring continued compliance
        with the highest ethical standards in the publishing industry.
      </p>
    </React.Fragment>
  );
};

export default BusinessModel;
